var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7534 11.5339L41.6714 10.6239L44.7534 9.82763V5.27771L48.2919 8.91765L53.2002 7.55267L50.9173 11.5339L53.2002 13.6951L50.1183 12.8988L44.7534 22.2262V11.5339Z",
    fill: "#2C97B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5652 17.7897L56.2823 15.5147L59.3643 16.311L61.6472 12.4435L62.9028 17.3347L67.8111 18.5859L63.9301 20.8609L64.7292 23.9321L62.4462 21.6571L53.0862 27.117L58.5652 17.7897Z",
    fill: "#2A3A7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7243 35.4208H57.8803L67.2403 30.0747L66.4413 27.0035L68.7243 29.1647L72.6052 27.0035L71.3496 31.8946L74.8882 35.4208H70.4365L69.5233 38.492L68.7243 35.4208Z",
    fill: "#2C97B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36787 35.4208H4.91615L8.45469 31.8946L7.08493 27.0035L11.0801 29.1647L13.363 27.0035L12.4498 30.0747L21.924 35.4208H11.0801L10.281 38.492L9.36787 35.4208Z",
    fill: "#2A3A7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6861 12.8988L26.6041 13.6951L28.887 11.5339L26.6041 7.55267L31.5124 8.91765L35.051 5.27771V9.82763L38.1329 10.6239L35.051 11.5339V22.2262L29.6861 12.8988Z",
    fill: "#2A3A7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5124 71.5925L26.6041 72.8437L28.887 68.9763L26.6041 66.7013L29.6861 67.4976L35.051 58.1702V68.9763L38.1329 69.7725L35.051 70.5688V75.1187L31.5124 71.5925Z",
    fill: "#2C97B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 69.3176L20.8968 65.2227L24.8919 66.2464L27.7456 69.0901L25.3485 73.185L19.9836 74.6637L18.4997 69.3176Z",
    fill: "#2C97B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3486 65.4501L22.3808 62.6064L28.3164 52.4828L35.0511 48.6154V56.3502L29.2296 66.4738L25.3486 65.4501Z",
    fill: "#2A3A7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7534 24.0461L50.5749 14.0363L54.4559 15.06L57.4237 17.9037L51.4881 28.0273L44.7534 31.8947V24.0461Z",
    fill: "#2A3A7E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9124 14.2636L52.0588 11.3062L54.4559 7.21123L59.8208 5.84625L61.3047 11.1924L58.9076 15.2873L54.9124 14.2636Z",
    fill: "#2C97B2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9017 63.1753L11.9934 61.8104L15.8744 59.5354L15.0754 56.578L17.3583 58.7392L26.7183 53.393L21.2393 62.7203L23.5222 64.9953L20.4403 64.0853L18.1573 68.0665L16.9017 63.1753Z",
    fill: "#2A3A7E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37279 60.1042L6.74254 54.758L10.966 52.3693L13.8196 55.213L14.847 59.1942L10.7377 61.4692L5.37279 60.1042Z",
    fill: "#2C97B2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6187 54.7577L13.5914 50.8903L23.7504 45.0891H31.5124L27.6314 51.8002L17.4724 57.6014L14.6187 54.7577Z",
    fill: "#2A3A7E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5398 45.0891H35.051V47.4778L29.2295 50.8903L32.5398 45.0891Z",
    fill: "#2C97B2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2921 35.4208L52.1731 28.7097L62.3321 22.7948L65.1858 25.7522L66.2131 29.6197L56.054 35.4208H48.2921Z",
    fill: "#2A3A7E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7534 35.4205V32.9181L50.5749 29.6194L47.1505 35.4205H44.7534Z",
    fill: "#2C97B2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9847 25.1835L64.9573 21.3161L69.0666 18.9274L74.4315 20.4061L72.9476 25.7522L68.8383 28.0272L65.9847 25.1835Z",
    fill: "#2C97B2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45469 48.6155L4.91615 45.0893H9.36787L10.281 42.0181L11.0801 45.0893H21.924L12.4498 50.4354L13.363 53.5066L11.0801 51.2317L7.08493 53.5066L8.45469 48.6155Z",
    fill: "#2C97B2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00301 44.1792L0.00787354 40.198L4.00301 36.3306H8.68301L9.82448 40.198L8.68301 44.1792H4.00301Z",
    fill: "#2C97B2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.765 44.1792L10.7377 40.198L11.765 36.3306H23.408L30.2568 40.198L23.408 44.1792H11.765Z",
    fill: "#2A3A7E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2342 44.1795L31.1699 40.767L33.3386 42.0183L32.083 44.1795H25.2342Z",
    fill: "#2A3A7E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2822 44.1792L49.5476 40.198L56.2822 36.3306H68.0393L69.0667 40.198L68.0393 44.1792H56.2822Z",
    fill: "#2A3A7E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4655 38.4918L47.7212 36.3306H54.57L48.6343 39.743L46.4655 38.4918Z",
    fill: "#2A3A7E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.317 43.8648L70.1755 39.8837L71.317 36.0162H76.1111L79.9921 39.8837L76.1111 43.8648H71.317Z",
    fill: "#2C97B2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3583 21.6571L15.0754 23.9321L15.8744 20.8609L11.9934 18.5859L16.9017 17.3347L18.1573 12.4435L20.4403 16.311L23.5222 15.5147L21.2393 17.7897L26.7183 27.117L17.3583 21.6571Z",
    fill: "#2C97B2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74254 25.7522L5.37279 20.4061L10.7377 18.9274L14.847 21.3161L13.8196 25.1835L10.966 28.0272L6.74254 25.7522Z",
    fill: "#2C97B2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7504 35.4208L13.5914 29.6197L14.6187 25.7522L17.4724 22.7948L27.6314 28.7097L31.5124 35.4208H23.7504Z",
    fill: "#2A3A7E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2342 36.3306H32.083L33.3386 38.4918L31.1699 39.743L25.2342 36.3306Z",
    fill: "#2C97B2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7243 51.2317L66.4413 53.5066L67.2403 50.4354L57.8803 45.0893H68.7243L69.5233 42.0181L70.4365 45.0893H74.8882L71.3496 48.6155L72.6052 53.5066L68.7243 51.2317Z",
    fill: "#2A3A7E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1731 51.8002L48.2921 45.0891H56.054L66.2131 50.8903L65.1858 54.7577L62.3321 57.6014L52.1731 51.8002Z",
    fill: "#2A3A7E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7212 44.1795L46.4655 42.0183L48.6343 40.767L54.57 44.1795H47.7212Z",
    fill: "#2C97B2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9573 59.1942L65.9847 55.213L68.8383 52.3693L72.9476 54.758L74.4315 60.1042L69.0666 61.4692L64.9573 59.1942Z",
    fill: "#2C97B2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 11.1924L19.9836 5.84625L25.3485 7.21123L27.7456 11.3062L24.8919 14.2636L20.8968 15.2873L18.4997 11.1924Z",
    fill: "#2C97B2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3164 28.0273L22.3808 17.9037L25.3486 15.06L29.2296 14.0363L35.0511 24.0461V31.8947L28.3164 28.0273Z",
    fill: "#2A3A7E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5398 35.4205L29.2295 29.6194L35.051 32.9181V35.4205H32.5398Z",
    fill: "#2A3A7E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3643 64.0853L56.2823 64.9953L58.5652 62.7203L53.0862 53.393L62.4462 58.7392L64.7292 56.578L63.9301 59.5354L67.8111 61.8104L62.9028 63.1753L61.6472 68.0665L59.3643 64.0853Z",
    fill: "#2C97B2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7534 56.3502V48.6154L51.4881 52.4828L57.4237 62.6064L54.4559 65.4501L50.5749 66.4738L44.7534 56.3502Z",
    fill: "#2A3A7E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7534 47.4778V45.0891H47.1505L50.5749 50.8903L44.7534 47.4778Z",
    fill: "#2A3A7E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4559 73.185L52.0588 69.0901L54.9124 66.2464L58.9076 65.2227L61.3047 69.3176L59.8208 74.6637L54.4559 73.185Z",
    fill: "#2C97B2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4754 45.5442L35.9642 47.0229V44.1792H33.1105L34.5944 41.6767L32.0832 40.198L34.5944 38.833L33.1105 36.3306H35.9642V33.4869L38.4754 34.8518L39.8452 32.4631L41.3291 34.8518L43.8403 33.4869V36.3306H46.694L45.21 38.833L47.7213 40.198L45.21 41.6767L46.694 44.1792H43.8403V47.0229L41.3291 45.5442L39.8452 48.0466L38.4754 45.5442Z",
    fill: "#2A3A7E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7534 70.5688L41.6714 69.7725L44.7534 68.9763V58.1702L50.1183 67.4976L53.2002 66.7013L50.9173 68.9763L53.2002 72.8437L48.2919 71.5925L44.7534 75.1187V70.5688Z",
    fill: "#2A3A7E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 68.294V56.578L39.845 49.8668L43.8402 56.578V68.294L39.845 69.3177L35.964 68.294Z",
    fill: "#2A3A7E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 48.0465L38.1328 46.7953L39.3884 48.9565L35.964 54.7576V48.0465Z",
    fill: "#2A3A7E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4159 48.9565L41.6716 46.7953L43.8403 48.0465V54.7576L40.4159 48.9565Z",
    fill: "#2C97B2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 76.0288V71.2514L39.845 70.2277L43.8402 71.2514V76.0288L39.845 80.01L35.964 76.0288Z",
    fill: "#2C97B2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 9.14485V4.36743L39.845 0.5L43.8402 4.36743V9.14485L39.845 10.1686L35.964 9.14485Z",
    fill: "#2C97B2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 23.8185V12.2162L39.845 11.1925L43.8402 12.2162V23.8185L39.845 30.6434L35.964 23.8185Z",
    fill: "#2A3A7E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4159 31.5534L43.8403 25.6385V32.4634L41.6716 33.7147L40.4159 31.5534Z",
    fill: "#2A3A7E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 32.4634V25.6385L39.3884 31.5534L38.1328 33.7147L35.964 32.4634Z",
    fill: "#2C97B2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8452 44.748C42.3669 44.748 44.4111 42.7109 44.4111 40.1981C44.4111 37.6852 42.3669 35.6481 39.8452 35.6481C37.3236 35.6481 35.2793 37.6852 35.2793 40.1981C35.2793 42.7109 37.3236 44.748 39.8452 44.748Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.845 44.0654C41.9884 44.0654 43.726 42.3339 43.726 40.198C43.726 38.0621 41.9884 36.3306 39.845 36.3306C37.7016 36.3306 35.964 38.0621 35.964 40.198C35.964 42.3339 37.7016 44.0654 39.845 44.0654Z",
    stroke: "#2A3A7E",
    strokeWidth: 0.38,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.5bdf51ca0593383649b1e96cf29fb146.svg";
export { ForwardRef as ReactComponent };